module.exports = __webpack_public_path__ + "static/img/ask1-tit.4779423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask1-tit.png
// module id = xt5G
// module chunks = 0